var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.994,
    height: 58.786,
    viewBox: "0 0 66.994 58.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke-miterlimit:10;stroke-width:2px;}.a{stroke:#40b895;}.b{stroke:#4f4f4f;stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.007 1.052)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M58.095,78.777A14.094,14.094,0,0,0,61.721,70.1l-4.264-2.131a7.287,7.287,0,0,0-6.515,0L46.68,70.1a14.094,14.094,0,0,0,3.626,8.675c3.572,3.787,3.893,3.787,3.893,3.787S54.522,82.564,58.095,78.777Z",
    transform: "translate(-46.68 -67.203)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M123.042,216.364c-.307-3.483,2.593-6.585,6.477-6.927s7.283,2.2,7.59,5.687",
    transform: "translate(-110.889 -186.809)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M234.33,215.853c0-3.5,3.161-6.333,7.06-6.333s7.06,2.835,7.06,6.333",
    transform: "translate(-204.51 -186.904)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M345.01,214.542c.5-3.461,4.04-5.811,7.9-5.25s6.579,3.82,6.077,7.281",
    transform: "translate(-297.602 -186.643)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M101.08,156.657c5.428-8.75,15.843-14.667,27.8-14.667,12.239,0,22.863,6.2,28.175,15.292",
    transform: "translate(-92.435 -130.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M248.191,257.57v20.473c0,3.305-3.016,6.01-6.7,6.01",
    transform: "translate(-210.532 -227.319)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 3.382,
    transform: "translate(37.659 7.826)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M152.841,281.969a4.531,4.531,0,1,1-4.531-4.529A4.489,4.489,0,0,1,152.841,281.969Z",
    transform: "translate(-128.35 -244.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M334.148,278.941c-.6-.768,2.341-3.477,2.341-4.531a4.531,4.531,0,0,1,9.061,0c0,1.012,2.463,3.779,1.9,4.531",
    transform: "translate(-288.397 -237.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.374,328.453v3.955a5.771,5.771,0,0,1-5.754,5.754h-3.955a5.771,5.771,0,0,1-5.754-5.754v-3.955a5.782,5.782,0,0,1,3.96-5.467,4.525,4.525,0,0,0,7.207-.1A5.773,5.773,0,0,1,140.374,328.453Z",
    transform: "translate(-112.478 -282.258)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M347.264,347.942H335.188a1.172,1.172,0,0,1-1.168-1.168V334.7a1.172,1.172,0,0,1,1.168-1.168h12.076a1.172,1.172,0,0,1,1.168,1.168v12.076A1.172,1.172,0,0,1,347.264,347.942Z",
    transform: "translate(-288.358 -291.208)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.4201d4d6ef75cf0fdd41c794272728d8.svg";
export { ForwardRef as ReactComponent };